<template>
    <CustomButton
        theme="plain"
        class="ResetFilters"
        :class="{ 'ResetFilters--show': show }"
        @click="emits('clear-selections')"
    >
        <span class="ResetFilters__btn-content">
            <FontIcon size="xx-small" icon="close" color="lime-green" />
            Clear filters
        </span>
    </CustomButton>
</template>

<script setup>
defineProps({
    show: {
        type: Boolean,
        default: false,
    },
})

const emits = defineEmits(['clear-selections'])
</script>

<style lang="scss" scoped>
.ResetFilters {
    opacity: 0;
    pointer-events: none;
    white-space: nowrap;
    margin-right: 0.75rem;
    order: 2;
}

.ResetFilters--show {
    opacity: 1;
    pointer-events: all;
}

.ResetFilters__btn-content {
    display: flex;
    column-gap: 0.5rem;
}
</style>
